// src/pages/AdminStatsPage.js
import React, { useState, useEffect } from 'react';
import { getDashboardStats, getAlertas, resolverAlerta } from '../services/api';
import StatsCards from '../components/charts/StatsCards';
import ActivityChart from '../components/charts/ActivityChart';
import CostChart from '../components/charts/CostChart';
import UserChart from '../components/charts/UserChart';

const AdminStatsPage = () => {
  const [stats, setStats] = useState(null);
  const [alertas, setAlertas] = useState([]);
  const [periodo, setPeriodo] = useState('7d');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    cargarDatos();
    // Actualizar cada 30 segundos
    const interval = setInterval(cargarDatos, 30000);
    return () => clearInterval(interval);
  }, [periodo]);

  const cargarDatos = async () => {
    try {
      const [statsRes, alertasRes] = await Promise.all([
        getDashboardStats(periodo),
        getAlertas()
      ]);
      setStats(statsRes.data);
      setAlertas(alertasRes.data.alertas || []);
    } catch (error) {
      console.error('Error cargando estadísticas:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleResolverAlerta = async (id) => {
    try {
      await resolverAlerta(id);
      cargarDatos();
    } catch (error) {
      console.error('Error resolviendo alerta:', error);
    }
  };

  if (loading) return <div className="loading">Cargando estadísticas...</div>;

  return (
    <div className="admin-stats">
      <h1>📊 Estadísticas de KREAMUN</h1>

      {/* Selector de período */}
      <div className="periodo-selector">
        <button className={periodo === '24h' ? 'active' : ''} onClick={() => setPeriodo('24h')}>24h</button>
        <button className={periodo === '7d' ? 'active' : ''} onClick={() => setPeriodo('7d')}>7 días</button>
        <button className={periodo === '30d' ? 'active' : ''} onClick={() => setPeriodo('30d')}>30 días</button>
        <button className={periodo === '90d' ? 'active' : ''} onClick={() => setPeriodo('90d')}>90 días</button>
      </div>

      {/* Alertas */}
      {alertas.length > 0 && (
        <div className="alertas-section">
          <h2>⚠️ Alertas activas</h2>
          {alertas.map(alerta => (
            <div key={alerta.id} className={`alerta ${alerta.nivel}`}>
              <div className="alerta-header">
                <span className="alerta-tipo">{alerta.tipo}</span>
                <span className="alerta-fecha">{new Date(alerta.created_at).toLocaleString()}</span>
              </div>
              <p className="alerta-mensaje">{alerta.mensaje}</p>
              <button onClick={() => handleResolverAlerta(alerta.id)} className="btn-resolver">
                Marcar como resuelta
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Tarjetas de resumen */}
      {stats?.generales && <StatsCards stats={stats.generales} />}

      {/* Gráficos */}
      <div className="charts-grid">
        {stats?.actividad && stats.actividad.length > 0 && (
          <ActivityChart data={stats.actividad} />
        )}
        
        {stats?.costos && stats.costos.length > 0 && (
          <CostChart data={stats.costos} />
        )}
      </div>

      {/* Gráfico de usuarios y tabla Top 10 */}
      <div className="users-section">
        {stats?.topUsuarios && stats.topUsuarios.length > 0 && (
          <>
            <UserChart data={stats.topUsuarios} />
            
            {/* Tabla Top 10 con estilos mejorados */}
            <div className="top-usuarios">
              <h2>🏆 Top 10 Creadores</h2>
              <table className="tabla-top">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Usuario</th>
                    <th>Historias</th>
                    <th>Imágenes</th>
                    <th>Tokens</th>
                  </tr>
                </thead>
                <tbody>
                  {stats.topUsuarios.map((user, index) => (
                    <tr key={user.id}>
                      <td>{index + 1}</td>
                      <td>{user.username}</td>
                      <td>{user.historias}</td>
                      <td>{user.imagenes}</td>
                      <td>{user.tokens?.toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AdminStatsPage;